const box3Tab = document.querySelectorAll('.bottom-ul li')
const box3Splide =  new Splide( '#box3-splide',{
  perPage: 1,
  arrows: true,
  pagination: true,
  focus  : 'center'
} ).mount();

box3Tab.forEach((item, index) => {
  item.addEventListener('click',()=>{
    box3Tab.forEach(item => {
      item.classList.remove("active");
    })
    box3Tab[index].classList.add("active");
    box3Splide.go(index)
  })
  item.addEventListener('mouseover',()=>{
    box3Tab.forEach(item => {
      item.classList.remove("active");
    })
    box3Tab[index].classList.add("active");
    box3Splide.go(index)
  })
});

box3Splide.on('move', () => {
  const activeIndex = box3Splide.index;
  box3Tab.forEach(item => {
    item.classList.remove("active");
  })
  box3Tab[activeIndex].classList.add("active");
});